import { createStore } from 'vuex'

import menu from './modules/menu'
import user from './modules/user-info'
import env from './modules/env'
import microApp from './modules/micro-app'
import baseUrl from './modules/base-url'
import microAppCache from './modules/micro-app-cache'
export default createStore<Record<any, any>>({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    menu,
    user,
    env,
    baseUrl,
    microApp,
    microAppCache
  }
})
